<template>
  <v-container fluid>
    <Breadcrumbs :title="'Requisition'"></Breadcrumbs>
    <RequisitionListTable></RequisitionListTable>
  </v-container>
</template>

<script>
import RequisitionListTable from "@/components/Requisition/RequisitionListTable";
import { createNamespacedHelpers } from "vuex";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "ExpenseTypeList",
  components: {
    RequisitionListTable,
    Breadcrumbs,
  },

  data: function() {
    return {
      role: localStorage.getItem("role") || null,
      errors: null,
      loading: false,
      pageTitle: "Requisition List",
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },
};
</script>
